export function parseAppointmentDeposits(raw) {
  if (!raw) return [];
  let parsed = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(parsed)) return [];
  return parsed
    .filter((d) => d && (d.amount != null || d.label))
    .map((d) => ({
      id: d.id,
      amount: Number(d.amount || 0),
      label: d.label || "",
      createdAt: d.createdAt || d.created_at || null,
    }));
}

export function sumDeposits(deposits = []) {
  return (deposits || []).reduce(
    (sum, d) => sum + Number(d?.amount || 0),
    0
  );
}

export function amountDue(serviceTotal, tip = 0, deposits = []) {
  const due =
    Number(serviceTotal || 0) + Number(tip || 0) - sumDeposits(deposits);
  return Math.max(0, Math.round(due * 100) / 100);
}

export function formatMoney(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}
